// Accepts plain objects with a `message` too: our auth layer returns errors as
// `{ message, code, status }` (see AuthError in services/auth/types.ts), not as
// Error instances. Without this, every failed login said "An unexpected error
// occurred" instead of the real reason (D-063).
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message !== ''
  ) {
    return error.message;
  }
  return 'An unexpected error occurred';
}
